/**
 * modal-logic.ts — pure logic extracted from editor-modals-save.ts.
 *
 * Epic: docs/epics/active/ts-unit-testability-seams-260623/main.md Phase 2.
 * Design: docs/design/ts-unit-testability-seams-260623.md §4 + §7 (W-C spec).
 *
 * This module contains:
 *   - `IssueNode` / `IssueClass` — typed shapes for the struct-node issue mapping.
 *   - `computeIssueClass(node)` — pure function; no DOM; formerly `_computeIssueClass`
 *     in editor-modals-save.ts. Renamed from private (`_` prefix) to exported.
 *
 * `FocusTrap` lifted OUT to `../a11y-view/focus-trap.ts` (DRY Epic
 * pdf-editor-shared-a11y-view-dry-260810 §C.7 #14): the SR panels became the third
 * consumer, forcing the shared home (rule #11). The attestation + hotkey modals import
 * it from there now.
 *
 * What stays in editor-modals-save.ts:
 *   DOM event wiring, modal lifecycle (open/close functions), element creation,
 *   attestation form submit/revoke handlers, save button wiring.
 *
 * No DOM globals accessed at module scope — import-safe in any environment.
 */
// ─── computeIssueClass ───────────────────────────────────────────────────────
/**
 * Compute the issue-class CSS token for a struct node, or null if no issue.
 *
 * Pure function — no DOM, no side effects.
 * Extracted from the private `_computeIssueClass` in editor-modals-save.ts (Phase W-C).
 */
export function computeIssueClass(node) {
    if (node.role === "Figure" && !node.isDecorative && !node.altText) {
        return "issue-error";
    }
    return null;
}
